<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-26 14:45:54
 * @Description: 同步操作员至省平台
-->
<template>
  <div class="block">
    <template v-if="result[step.status] !== 'Y' && result[step.stepResults] && result[step.stepResults].length > 0">
      <template v-if="step.tplType === 'table' && result[step.stepResults] && result[step.stepResults].length > 1">
        <el-table
          :data="result[step.stepResults]"
          style="width: 100%;"
        >
          <el-table-column
            type="index"
            label="序号"
            width="40"
            align="center"
          />
          <el-table-column
            prop="createdTime"
            label="上传时间"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              {{ scope.row.createdTime ? scope.row.createdTime.substring(0, scope.row.createdTime.length - 2) : '-' }}
            </template>
          </el-table-column>

          <el-table-column
            prop="result"
            min-width="160"
            label="执行结果"
          >
            <template slot-scope="scope">
              <span :class="scope.row.status === 'Y' ? 'u-text-success' : 'u-text-danger'">
                {{ scope.row.result }}
              </span>
            </template>
          </el-table-column>
          <template v-if="result[step.flag]">
            <el-table-column
              v-for="(_item, _idx) in step.defineField"
              :key="_idx"
              :align="_item.align"
              prop="result"
              :min-width="_item.width"
              :label="_item.name"
            >
              <template
                slot-scope="scope"
              >
                <span
                  v-if="_item.type === 'text'"
                >
                  {{ scope.row.params[_item.value] }} {{ _item.dw }}
                </span>
                <el-link
                  v-else-if="_item.type === 'link'"
                  type="primary"
                  @click="(e) => handleLinkFunction(e, _item.key, scope.row.params, _item.id)"
                >
                  {{ scope.row.params[_item.value] }}
                </el-link>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </template>
      <template v-else>
        <div class="u-text-info dev-o-wbbg__info">
          <span
            v-for="(info, _i) in step.defineField"
            :key="_i"
          >
            {{ info.name }} ：
            <span
              v-if="info.type === 'text'"
            >
              {{ result[step.stepResults][0].params[info.value] }} {{ info.dw }}
            </span>
            <span
              v-if="info.type === 'array'"
            >
              {{ result[step.stepResults][0].params[info.value1] }} 至 {{ result[step.stepResults][0].params[info.value2] }}
            </span>
            <el-link
              v-else-if="info.type === 'link'"
              :disabled="info.loading && result[step.stepResults][0].params.previewPdf"
              type="primary"
              @click="(e) => handleLinkFunction(e, info.key, result[step.stepResults][0].params, info.id)"
            >
              {{ result[step.stepResults][0].params[info.value] }}【点击链接查看】
              <i
                v-show="info.loading && result[step.stepResults][0].params.previewPdf"
                class="el-icon-loading"
              />
            </el-link>

            <br>
          </span>

          <span>失败原因 ：<span
            class="u-text-danger"
            style="margin-left: 2px;"
          >{{ result[step.stepResults][0].result }}</span></span>
        </div>
      </template>
    </template>
    <p
      v-if="step.tplType === 'table' && result[step.stepResults] && result[step.stepResults].length > 1 && (result[step.successNum] > 1 || result[step.failNum] > 0)"
      class="u-text-info"
    >
      共计 成功
      <span class="u-text-success">{{ result[step.successNum] }} </span> 条，
      失败 <span class="u-text-danger">{{ result[step.failNum] }} </span> 条
    </p>
  </div>
</template>

<script>

export default {
  name: 'GdUploadStepResult',
  props: {
    step: {
      type: Object,
      default: function () {
        return {};
      }
    },
    result: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading建筑类别
      dialogShow: true, // 模态框dialog显示

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */

      // step: {}

    };
  },
  computed: {
  },
  methods: {
    handleLinkFunction (e, key, _value, _id) {
      this.$emit('callback', e, { key: key, value: _value, id: _id });
    }
  },
  created () {
  }
};
</script>
<style lang="scss" scoped>
.dev-o-wbbg__result{
  h4{
    padding: 15px 5px;
  }

  p{
    padding: 8px 5px;
  }

  span{
    padding: 4px 2px;
    margin-top: 2px;
  }

  // .el-table {
  //   padding: 8px 10px;
  // }
}

.dev-o-wbbg__comment{
  font-weight: normal;
}

.dev-o-wbbg__info{
  line-height: 20px;

  .el-link{
    padding: 2px;
  }
}

.dev-o-wbbg__list{
  line-height: 20px;

  // li::before{
  //   margin-left: 20px;
  //   color: #999;
  //   list-style-type: disc;
  // }
  li::before{
    content: "";
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    margin-top: 6px;
    margin-left: 2px;
    border-radius: 50%;
    background-color: #bcc8cf;
  }

  &-name{
    margin-left: 16px;
    font-weight: bold;
  }

}

</style>
